// extracted by mini-css-extract-plugin
export default {"wrapper":"ModifyLog_wrapper__jvHCF","table_wrapper":"ModifyLog_table_wrapper__dUPXB","afterValue":"ModifyLog_afterValue__vQPhO","modalWrapper":"ModifyLog_modalWrapper__IB0rA"};